import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RouterMain from './router';
import { UiFeedbackProvider } from './utils/context/ui-feedback-context';
import i18n from './utils/i18n/i18n';
import { STRING_LANGUAGE_COMPRARTODO } from './utils/const/string-const';

const savedLanguage = localStorage.getItem(STRING_LANGUAGE_COMPRARTODO);
if (savedLanguage && savedLanguage !== i18n.language) {
  i18n.changeLanguage(savedLanguage);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UiFeedbackProvider>
      <RouterMain />
    </UiFeedbackProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
